import React from "react";
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';
import '../../../../../assets/scss/4_components/lib/_dateTimePicker.scss'
import moment, { Moment } from "moment";
import { Label } from "react-aria-components";

interface IFormDatePicker {
    value: Date | Moment | null;
    label: string;
    required?: boolean;
    onChange: (date: Date | null) => void;
    validateRule?: (date: Date | null) => boolean;
    validationError?: string;
    className?: string;
    disabled?: boolean;
}

export default function FormDatePicker({
    value,
    label,
    required = false,
    onChange,
    validateRule,
    validationError,
    className,
    disabled = false,
}: IFormDatePicker) {
    const [isValid, setIsValid] = React.useState<boolean | undefined>();

    const handleChange = (date: string | Moment | null) => {
        let newDate: Date | null = null;

        if (date && moment.isMoment(date)) {
            newDate = date.toDate();
        }

        if (validateRule) {
            setIsValid(validateRule(newDate));
        }

        onChange(newDate);
    };

    return (
        <div className={`form-date-picker-wrapper ${className ?? ''}`}>
            {label && <Label className="small margin__bottom--xxs display--block">{label}{required ? " (required)" : ""}</Label>}
            <Datetime
                value={value ? moment(value) : undefined}
                onChange={handleChange}
                inputProps={{
                    disabled,
                    className: isValid === false ? 'react-datetime--error' : '',
                }}
                dateFormat="DD-MM-YYYY"
                timeFormat={false} // date-only
            />
            {validationError && isValid === false && (
                <div className="form-date-picker-error">{validationError}</div>
            )}
        </div>
    );
}
